import React from 'react';

import Thumb from '../img/timer-thumb.png';
import LatestWork from '../img/timer-latest-work.png';
import Offer from '../img/timer-offer.png';

const TimerWPTheme = {
    id: 38, permalink: "timer-wp-theme", thumb: Thumb, title: "Timer WordPress Theme", category: "WordPress", categoryURL: "wordpress", detailImg1: LatestWork, detailImg2: Offer, previewTxt: "", previewURL: "", sourceTxt: "GitHub", sourceURL: "https://github.com/wasek23/timer-wp-theme", description: <>
        <h3 className="mbSmall">Timer is a WordPress Theme.</h3>
        <p>&nbsp;</p>

        <h5>Main Feature:</h5>
        <ul>
            <li>4+ type posts- latest works, feature offers, team members, blogs.</li>
            <li>Left/Right Sidebar or full width blog page</li>
            <li>Google Map Added in contact page</li>
            <li>Integrated Redux theme customizer</li>
        </ul>

        <h5>Technology Used:</h5>
        <ul>
            <li>WordPress, PHP, JavaScript, jQuery, HTML, CSS, Redux</li>
        </ul>
    </>
};
export default TimerWPTheme;